<template>
  <el-dialog
    title=""
    :visible.sync="$store.state.magazine.magazineFalg"
    width="50%"
    :append-to-body="true"
    :close-on-click-modal="false"
    center>

      <div class="tabs-container ng-scope">
        <div class="row">
          <div class="col-sm-12">
            <div class="ibox float-e-margins">
            <el-tabs type="border-card" v-model="langCode" @tab-click="handleClick">
              <el-tab-pane
                :label="$t('message.' + langItem.langCode)"
                :name="langItem.langCode"
                v-for="(langItem, index) in $store.state.magazine.editorial.langMap"
              >
              <div class="ibox-content">
                <div class="row table-responsive" style="padding-bottom:60px;">
                  <div class="col-sm-12"  style="text-align: center;padding-bottom:30px;">
                    <div class="previewImage">
                      <div class="titleItem">
                        <div class="editorialTitle">{{getObject($store.state.magazine.editorial.langMap,langItem.langCode).cardTitle}}</div>
                        <div class="cardTitle">{{getObject($store.state.magazine.editorial.langMap,langItem.langCode).editorialTitle}}</div>
                      </div>
                      <img :src="getObject($store.state.magazine.editorial.langMap,langItem.langCode).image" />
                    </div>
                  </div>
                  <div class="col-sm-12" style="text-align: center;" v-show="$store.state.magazine.editorial.type==1">
                      <div style="height: 700px;max-width: 450px;min-width: 320px; display: inline-block">
                        <iframe id="landingPage" :src="magazineUrl"  width="100%" height="700px"></iframe>
                      </div>
                  </div>
                </div>
              </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
  </el-dialog>
</template>
<script>
import config from "../../config";
export default {
  mixins: [config.globalMixin],
  name: "magazineDlgController",
  props:['rnd'],
  data() {
    return {
      magazineUrl:"",
      langCode:"en_US"
    };
  },
  methods: {
    cancel: function() {
      this.$store.commit("setmagazine", { string: "", boolean: false });
    },
    handleClick(tab, event) {
      this.langCode = tab.name;
      this.refreshEvent();
    },
    refreshEvent(){
      var rnd = Date.now();
      this.magazineUrl = "";
      var that = this;
      setTimeout(function(){
        that.magazineUrl = process.env.VUE_APP_API_WEBDOMAIN + 'editorial?id='+that.$store.state.magazine.editorial.id + "&rnd="+rnd+"&lang="+that.langCode+"&cmspreview=true";
      },200)
    }
  },
  mounted: function() {},
  watch: {
    rnd: function() {
      this.refreshEvent()
    },
  }
};
</script>
